import { Routes, RouterModule }  from '@angular/router';

import { Learner } from './components/main/learner.component';
import { ProductView } from './../../modules/shared-postlogin/components/product-view/product-view.component';
import { ActivityLaunch } from './../../modules/shared-postlogin/components/activity-launch/activity-launch.component';
import { ProductViewResolverService } from './../../modules/shared-postlogin/services/product-view-resolver.service';
import { SaveWarningGuard } from './../shared-postlogin/services/save-warning-guard.service';
import { CanDeactivateLPGuard } from './../shared-postlogin/services/can-deactivate-lp-guard.service';
import { LearnerAuthGuard } from './services/learner-auth-guard.service';
import { SubmitLtiTest } from '../shared-postlogin/components/submit-lti-test/submit-lti-test.component';
import { AttemptsExceeded } from '../shared-postlogin/components/attempts-exceeded/attempts-exceeded.component'
import { CreateUserAnalytics } from './components/create-user-analytics/create-user-analytics.component';

const routes: Routes = [
    {
        path: 'learner', component: Learner, canActivate: [LearnerAuthGuard], children: [
            {
                path: ':spaceid/product/:productcode', component: ProductView, canDeactivate: [CanDeactivateLPGuard], resolve: { resolveData: ProductViewResolverService }, children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data : { source : 'LEARNER_LAUNCH_FROM_DASHBOARD'} }
                ]
            },
            {
                path: ':spaceid/product/:productcode/class/:classid', component: ProductView, canDeactivate: [CanDeactivateLPGuard], resolve: { resolveData: ProductViewResolverService }, children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data : { source : 'LEARNER_LAUNCH_FROM_DASHBOARD'} }
                ]
            },
            {
                path: ':spaceid/product/:productcode/class/:classid/unit/:unitcode', component: ProductView,
                canDeactivate: [ CanDeactivateLPGuard ],
                resolve: { resolveData: ProductViewResolverService },
                children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data: { source: 'LEARNER_LAUNCH_FROM_DASHBOARD' } }
                ]
            },
            {
                path: ':spaceid/product/:productcode/class/:classid/unit/:unitcode/activity/:activityId', component: ProductView,
                canDeactivate: [ CanDeactivateLPGuard ],
                resolve: { resolveData: ProductViewResolverService },
                children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data: { source: 'LEARNER_LAUNCH_FROM_DASHBOARD' } }
                ]
            },
            {
                path: ':spaceid/class/:classid/product/:productcode/assignment/:assignmentid', component: ProductView, canDeactivate: [CanDeactivateLPGuard], resolve: { resolveData: ProductViewResolverService }, children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data : { source : 'LEARNER_ATTEMPT_ASSIGNMENT'} }
                ]
            },
            {
                path: ':spaceid/class/:classid/product/:productcode/review-assignment/:assignmentid', component: ProductView, canDeactivate: [CanDeactivateLPGuard], resolve: { resolveData: ProductViewResolverService }, children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data : { source : 'LEARNER_REVIEW_TEST'} }
                ]
            },
            {
                path: ':spaceid/class/:classid/product/:productcode/cefr-review/:assignmentid', component: ProductView, resolve: { resolveData: ProductViewResolverService }, children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data: { source: 'LEARNER_CEFR_REVIEW_TEST' } }
                ]
            },
            {
                path: ':spaceid/class/:classid/product/:productcode/cefr-review', component: ProductView, resolve: { resolveData: ProductViewResolverService }, children: [
                    { path: 'item/:itemid', canDeactivate: [SaveWarningGuard], component: ActivityLaunch, data: { source: 'LEARNER_CEFR_REVIEW_TEST' } }
                ]
            },
            {
                path: ':spaceid/createUA/product/:productcode/class/:classid', component: CreateUserAnalytics
            },
            {
                path: 'lti/submit/:ltiParamsKey', component : SubmitLtiTest
            },
            {
                path: 'lti/attempts-exceeded/:attemptLimit', component: AttemptsExceeded
            }
        ]
    }
];

export const ROUTES = RouterModule.forChild(routes);
